export default {
	props: {
		min: {
			type: Number,
			default: null
		},
		max: {
			type: Number,
			default: null
		},
		decimals: {
			type: Number,
			default: 2
		},
		preffix: {
			type: String,
			default: ''
		},
		step: {
			type: [String, Number],
			default: 1
		}
	},
	data() {
		return {
			numberDefaultValue: null
		};
	},
	methods: {
		numberFormatter(value) {
			if (this.preffix) return `${value}${this.preffix}`;
			return value;
		},
		numberParser(value) {
			if (this.preffix) return value.replace(this.preffix, '');
			return value;
		},
		numberChange(value) {
			const parsedValue = this.parseValue(value);
			this.$emit('input', parsedValue);
		},
		numberIntParseValue(value) {
			const int = parseInt(value, 10);
			if (!Number.isNaN(int)) return int;
			return value;
		},
		numberDecParseValue(value) {
			value = value.toString().replace(',', '.');
			const val = parseFloat(value, 10);
			if (!Number.isNaN(val)) return val;
			return value;
		},
		numberParseDefaultValue() {
			if (!Number.isNaN(this.defaultValue)) return this.defaultValue;
			return this.numberDefaultValue;
		}
	}
};
